import React from 'react';
import { useBlogUtils } from 'src/hooks/useBlogUtils';

export default function BlogCard1(props) {
  const { gotToBlog } = useBlogUtils();

  return (
    <div
      id="users_list"
      className="blog-card-main-wrapper tw-cursor-pointer"
      onClick={() => gotToBlog(props?.slug_url)}
    >
      <div
        id={props?.page_id}
        key={props?.page_id}
        className={`list-card list-card-blog w-100-l flex flex-column relative`}
      >
        <div className="flex flex-column items-center">
          <div className="blog-image flex items-center justify-center relative">
            {props?.featured_image ? (
              <img
                id={props?.page_id + '_' + 'image'}
                src={props?.featured_image}
                className="card-image"
              ></img>
            ) : null}
            {props?.updated_date ? (
              <div className="date-box f5 flex flex-column justify-center items-center">
                <div className="f3 fw6">{props?.updated_date}</div>
                <div className="month-selected">{props?.updated_date}</div>
              </div>
            ) : null}
          </div>
          <div className="w-100 card-body">
            {props?.page_name ? (
              <div id={props?.page_id + '_' + 'blog-heading'} className="mb2 f4 fw7">
                {props?.page_name}
              </div>
            ) : null}
            {props?.excerpt ? (
              <div id={props?.page_id + '_' + 'blog-body'} className="pb4">
                <span className="f5 o-50 card-body__text">
                  {props?.excerpt.replace(/<[^>]*>/g, '').slice(0, 150)}
                  ...{' '}
                </span>{' '}
                <span className="fw6 f5 underline-hover pointer">Read Full Blog</span>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
